import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authMe, authLogin, authRegister, authLogout, authGoogleCallback } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const u = await authMe();
      setUser(u);
      return u;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    // CRITICAL: skip /me on Google callback so AuthCallback can establish session first
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = async (email, password) => {
    const data = await authLogin({ email, password });
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const data = await authRegister(payload);
    setUser(data.user);
    return data.user;
  };

  const googleCallback = async (sessionId) => {
    const data = await authGoogleCallback(sessionId);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await authLogout(); } catch {}
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, googleCallback, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
